import { ApiClient } from '../../api-client/api-client';

export const getMeetingMinutesTaskSummary = async (projectId: string, documentId: string) => {
  return ApiClient.getExtractionSummary({ projectId, documentId }).then((res) => res.data);
};
